import request from '@/utils/request'

let PointSettingApi = {
    /*保存配置*/
    saveConfig(data) {
        return request._post('/shop/plus.points.setting/index', data);
    },
    /*保存配置*/
    getConfig(data) {
        return request._get('/shop/plus.points.setting/index', data);
    }
}
export default PointSettingApi;



// WEBPACK FOOTER //
// ./src/api/pointsstting.js